import axios from 'axios';
import { apiUrl } from '../../../../../constants/global';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const baseUrl = apiUrl + 'v2';

const headers = () => ({
  Authorization: `Bearer ${user?.token}`,
  'Content-Type': 'application/json',
});

export async function getAuctionStatistics(params = {}) {
  try {
    const query = new URLSearchParams(
      Object.fromEntries(Object.entries(params).filter(([_, v]) => v !== null && v !== '' && v !== undefined))
    ).toString();
    const response = await axios.get(`${baseUrl}/statistics/auctions?${query}`, { headers: headers() });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch auction statistics', error);
    return { success: false, data: null };
  }
}